import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  IconButton,
  ListItemText,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Typography,
  Skeleton,
  Box,
  Tooltip,
} from "@mui/material";
import "./Calendar.css";
import CloseIcon from "@mui/icons-material/Close";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useProSidebar } from "react-pro-sidebar";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  CalendarpostData,
  DashcalpostData,
} from "../../store/reducers/Formapireducer";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const Datavisual1 = () => {
  const calendarRef = useRef(null);
  const calendarInstanceRef = useRef(null);
  const [eventsData, setEventsData] = useState([]);
  const [DialogData, setDialogData] = useState([]);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [clickedDate, setClickedDate] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isTodayDialog, setIsTodayDialog] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [taskLoading, setTaskLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const [currentDayTasks, setCurrentDayTasks] = useState([]);
  const [yesterdayTasks, setYesterdayTasks] = useState([]);
  const [backlogTasks, setBacklogTasks] = useState([]);
  const [blockedTasks, setBlockedTasks] = useState([]);

  const [activeTab, setActiveTab] = useState("todo"); // or 'approved'
  const [notApprovedTasks, setNotApprovedTasks] = useState([]);
  const [isToday, setIsToday] = useState(false);
  const isManager = sessionStorage.getItem("isManager");

  const calendardata = useSelector((state) => state.formApi.calendardata);
  const calenderEmpRecordID = useSelector(
    (state) => state.formApi.calenderEmpRecordID,
  );
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  };
  const dispatch = useDispatch();
  const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, "0");
  const statusColorMap = {
    Completed: "#4CAF50",
    Inprogress: "#FF9800",
    "Transfer to": "#FFC107",
    "Not yet started": "#98AFC7",
  };
  let formattedYesterday = "";
  let formattedTomorrow = "";

  if (clickedDate && !isNaN(new Date(clickedDate))) {
    const date = new Date(clickedDate);

    // Yesterday
    const yesterdayDate = new Date(date);
    yesterdayDate.setDate(yesterdayDate.getDate() - 1);
    formattedYesterday = yesterdayDate.toISOString().split("T")[0];

    // Tomorrow
    const tomorrowDate = new Date(date);
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    formattedTomorrow = tomorrowDate.toISOString().split("T")[0];
  }

  const handleCardClick = (RecordID, TaskDate, EmployeeAttendanceID, Type) => {
    setOpen(false);
    if (Type == "MT") {
      navigate(
        `/Apps/Secondarylistview/TR263/Tasks/${EMPID}/EditTasks/${RecordID}/E`,
      );
    } else {
      navigate(
        `/Apps/Secondarylistview/TR132/ScrumTask/${EmployeeAttendanceID}/${TaskDate}/EditScrumTask/${RecordID}/${Type}`,
      );
    }
  };
  useEffect(() => {
    setTodayBacklogCount(0); // ✅ prevent stale count
  }, [calenderEmpRecordID]);

  const currentYearRef = useRef(new Date().getFullYear().toString());

  //finally i was changes instaed of that
  useEffect(() => {
    if (!EMPID) return;

    const fetchCalendar = async () => {
      try {
        const resultAction = await dispatch(
          DashcalpostData({
            // Year: "2026",
            Year: currentYearRef.current,
            Month: "01,02,03,04,05,06,07,08,09,10,11,12",
            EmployeeID: EMPID,
          }),
        ).unwrap();

        if (resultAction.Status === "Y") {
          setEventsData(resultAction.Data);
        }
      } catch (error) {
        console.error("Error fetching calendar:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendar();
  }, [EMPID, dispatch]);

  const [todayBacklogCount, setTodayBacklogCount] = useState(0);
  console.log("🚀 ~ Datavisual1 ~ todayBacklogCount:", todayBacklogCount);
  useEffect(() => {
    const fetchTodayBacklog = async () => {
      const istOffset = 5.5 * 60 * 60 * 1000;
      const now = new Date(new Date().getTime() + istOffset);
      const today = now.toISOString().split("T")[0];

      try {
        const response = await dispatch(
          CalendarpostData({
            CurDate: today,
            EmployeeID: calenderEmpRecordID,
          }),
        );

        if (response.payload?.Status === "Y") {
          const BackLog = response.payload.Data?.BackLog;
          setTodayBacklogCount(Array.isArray(BackLog) ? BackLog.length : 0);
        }
      } catch (err) {
        console.error("Backlog count fetch failed", err);
      }
    };

    if (calenderEmpRecordID) {
      fetchTodayBacklog();
    }
  }, [dispatch, calenderEmpRecordID]);

  const currentDate = new Date();
  const currentDateString = currentDate.toISOString().split("T")[0];

  // useEffect(() => {
  //   if (calendarRef.current && !loading) {
  //     if (calendarInstanceRef.current) {
  //       calendarInstanceRef.current.destroy();
  //     }

  //     //Dot Icon Onclick
  //     const handleDotClick = async (date) => {
  //       const istOffset = 5.5 * 60 * 60 * 1000;
  //       const localDate = new Date(date.getTime() + istOffset);
  //       const clicked = localDate.toISOString().split("T")[0];

  //       const now = new Date(new Date().getTime() + istOffset);
  //       const today = now.toISOString().split("T")[0];

  //       setClickedDate(clicked);
  //       setIsTodayDialog(clicked === today); // ✅ This sets isTodayDialog, not isToday
  //       setSelectedDate(date);
  //       setDialogOpen(true);
  //       setOpen(true);
  //       setTaskLoading(true);

  //       try {
  //         const response = await dispatch(
  //           CalendarpostData({
  //             CurDate: clicked,
  //             EmployeeID: calenderEmpRecordID,
  //           }),
  //         );

  //         if (response.payload.Status === "Y") {
  //           // const { CurrentdayData, ScheduledAssignedData, BackLogData, BlockedData } = response.payload.Data;
  //           const { Todo, BackLog, Completed, BlockedApproved, NotApproved } =
  //             response.payload.Data;
  //           setCurrentDayTasks(Todo || []);
  //           setYesterdayTasks(BackLog || []);
  //           setBacklogTasks(Completed || []);
  //           setBlockedTasks(BlockedApproved || []);
  //           setNotApprovedTasks(NotApproved || []);
  //           // setCurrentDayTasks(CurrentdayData || []);
  //           // setYesterdayTasks(ScheduledAssignedData || []);
  //           // setBacklogTasks(BackLogData || []);
  //           // setBlockedTasks(BlockedData || []);
  //         } else {
  //           toast.error(response.payload.Msg || "Something went wrong");
  //         }
  //       } catch (error) {
  //         toast.error("Failed to load tasks");
  //         console.error("Error fetching task data:", error);
  //       } finally {
  //         setTaskLoading(false);
  //       }
  //     };

  //     //Plus Icon Onclick

  //     const handlePlusClick = async (date) => {
  //       const istOffset = 5.5 * 60 * 60 * 1000;
  //       const localDate = new Date(date.getTime() + istOffset);
  //       const clicked = localDate.toISOString().split("T")[0];
  //       console.log(clicked, "--clicked");

  //       const now = new Date(new Date().getTime() + istOffset);
  //       const today = now.toISOString().split("T")[0];

  //       if (isManager == 0) {
  //         navigate("/Apps/TR132/Scrum%20Task/EditScrum%20Task/-1/A", {
  //           state: {
  //             ClickedDate: clicked,
  //           },
  //         });
  //       } else if (isManager == 1 && EMPID == calenderEmpRecordID) {
  //         // navigate("/Apps/Secondarylistview/TR263/Task%20List/132/EditTask%20List/-1/A");
  //         navigate("/Apps/TR132/Scrum%20Task/EditScrum%20Task/-1/A", {
  //           state: {
  //             ClickedDate: clicked,
  //           },
  //         });
  //       } else {
  //         navigate(
  //           "/Apps/Secondarylistview/TR263/Task%20List/132/EditTask%20List/-1/A",
  //         );
  //       }
  //     };
  //     const formatDate = (date) => {
  //       if (!date) return "";
  //       const d = new Date(date);
  //       return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  //     };

  //     const calendar = new Calendar(calendarRef.current, {
  //       plugins: [dayGridPlugin],
  //       initialView: "dayGridMonth",
  //       initialDate: currentDateString,
  //       events: calendardata,
  //       // events: eventsData,
  //       eventClick: function (info) {
  //         const clickedDate = info.event.start;
  //         if (!clickedDate || isNaN(new Date(clickedDate).getTime())) return;
  //         const ID = info.event.extendedProps.DailyID;
  //         // const formattedDate = `${clickedDate.getFullYear()}-${String(
  //         //   clickedDate.getMonth() + 1
  //         // ).padStart(2, "0")}-${String(clickedDate.getDate()).padStart(
  //         //   2,
  //         //   "0"
  //         // )}`;
  //         // const formattedDate = `${String(clickedDate.getDate()).padStart(2, "0")}-${String(
  //         //   clickedDate.getMonth() + 1
  //         // ).padStart(2, "0")}-${clickedDate.getFullYear()}`;

  //         //fetchTasks(formattedDate, ID);
  //       },

  //       eventDidMount: function (info) {
  //         const calendar = info.view.calendar;
  //         const eventDate = info.event.startStr.split("T")[0];
  //         const status = info.event.extendedProps?.status?.trim();
  //         let starColor = "#000";
  //         const eventsForDate = calendar
  //           .getEvents()
  //           .filter((e) => e.startStr.startsWith(eventDate));

  //         // Combine all titles for tooltip
  //         const tooltipText = eventsForDate
  //           .map((e) => `★ ${e.title}`)
  //           .join("\n");

  //         if (status && statusColorMap[status]) {
  //           starColor = statusColorMap[status];
  //         }

  //         const defaultTitle = info.el.querySelector(".fc-event-title");
  //         if (defaultTitle) defaultTitle.style.display = "none";
  //         info.el.innerHTML = "";

  //         info.el.style.backgroundColor = "transparent";
  //         info.el.style.border = "none";
  //         info.el.style.boxShadow = "none";
  //         info.el.style.padding = "0px";
  //         info.el.style.display = "flex";
  //         info.el.style.alignItems = "flex-start";
  //         info.el.style.justifyContent = "flex-start";
  //         info.el.style.flexDirection = "row";
  //         info.el.style.flexWrap = "wrap";
  //         info.el.style.fontSize = "9px";
  //         info.el.style.fontWeight = "bold";
  //         info.el.style.whiteSpace = "normal";
  //         info.el.style.overflow = "hidden";
  //         info.el.style.textOverflow = "ellipsis";

  //         const starIcon = document.createElement("span");
  //         starIcon.innerHTML = "★";
  //         starIcon.style.color = starColor;
  //         starIcon.style.fontSize = "12px";
  //         starIcon.style.marginRight = "4px";
  //         starIcon.style.display = "inline-flex";
  //         starIcon.style.alignItems = "flex-start";
  //         starIcon.style.flexShrink = "0";
  //         starIcon.style.marginTop = "-2px";

  //         const titleElement = document.createElement("span");
  //         titleElement.innerText = info.event.title;
  //         titleElement.style.color = "#000";
  //         titleElement.style.display = "inline";
  //         titleElement.style.wordBreak = "break-word";
  //         titleElement.style.flex = "1";

  //         info.el.appendChild(starIcon);
  //         info.el.appendChild(titleElement);
  //         info.el.setAttribute("title", tooltipText);
  //       },

  //       dayCellDidMount: function (info) {
  //         const now = new Date();
  //         const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  //         const IST_OFFSET = 5.5 * 60 * 60 * 1000;
  //         const istNow = new Date(utc + IST_OFFSET);

  //         const todayDate = new Date(
  //           istNow.getFullYear(),
  //           istNow.getMonth(),
  //           istNow.getDate(),
  //         );

  //         const yesterdayDate = new Date(todayDate.getTime() - 86400000);

  //         const cellDate = new Date(
  //           info.date.getFullYear(),
  //           info.date.getMonth(),
  //           info.date.getDate(),
  //         );

  //         if (cellDate.getTime() === todayDate.getTime()) {
  //           info.el.style.backgroundColor = "#2196F3"; // Today → Blue
  //           info.el.style.color = "#fff";
  //         } else if (cellDate.getTime() === yesterdayDate.getTime()) {
  //           info.el.style.backgroundColor = ""; // Yesterday → Default
  //           info.el.style.color = "#000";
  //         }

  //         // ✔️ Add checkerboard here AFTER today/yesterday logic
  //         if (cellDate.getTime() === todayDate.getTime()) {
  //           info.el.style.backgroundColor = "#2196F3"; // today
  //           info.el.style.color = "#fff";
  //         } else {
  //           // Checkerboard applies to all non-today cells
  //           const dayOfMonth = cellDate.getDate();
  //           if (dayOfMonth % 2 === 0) {
  //             info.el.style.backgroundColor = "#d0f0e0";
  //           } else {
  //             info.el.style.backgroundColor = "";
  //           }
  //         }
  //         // Prevent duplicate dots
  //         if (info.el.querySelector(".dot-button")) return;

  //         // Ensure the parent container is positioned relatively
  //         info.el.style.position = "relative";

  //         // Create a container to hold the button separately
  //         const buttonContainer = document.createElement("div");
  //         buttonContainer.style.position = "absolute";
  //         buttonContainer.style.bottom = "2px";
  //         buttonContainer.style.right = "2px";
  //         buttonContainer.style.zIndex = "10"; // Make sure it stays clickable and on top

  //         // 🔹 Backlog count ONLY for today
  //         if (
  //           cellDate.getTime() === todayDate.getTime() &&
  //           todayBacklogCount > 0
  //         ) {
  //           const backlogLabel = document.createElement("div");
  //           backlogLabel.innerText = `B(${todayBacklogCount})`;

  //           backlogLabel.style.fontSize = "11px";
  //           backlogLabel.style.fontWeight = "bold";
  //           backlogLabel.style.color = "#f44336";
  //           backlogLabel.style.background = "#fff";
  //           backlogLabel.style.borderRadius = "4px";
  //           backlogLabel.style.padding = "2px";
  //           backlogLabel.style.pointerEvents = "none";
  //           buttonContainer.appendChild(backlogLabel);
  //         }
  //         const dotButton = document.createElement("button");
  //         dotButton.innerHTML = "⋯";
  //         dotButton.className = "dot-button";
  //         dotButton.style.border = "none";
  //         dotButton.style.background = "transparent";
  //         dotButton.style.cursor = "pointer";
  //         dotButton.style.fontSize = "16px";
  //         dotButton.style.padding = "0";
  //         dotButton.style.margin = "0";

  //         dotButton.addEventListener("click", (e) => {
  //           e.stopPropagation();
  //           handleDotClick(info.date);
  //         });

  //         const plusButton = document.createElement("button");
  //         plusButton.innerHTML = "+";
  //         plusButton.className = "plus-button";
  //         plusButton.style.border = "none";
  //         plusButton.style.background = "transparent";
  //         plusButton.style.cursor = "pointer";
  //         plusButton.style.fontSize = "16px";
  //         plusButton.style.padding = "0";
  //         plusButton.style.margin = "0";

  //         // plus Icon
  //         plusButton.addEventListener("click", (e) => {
  //           e.stopPropagation();
  //           handlePlusClick(info.date);
  //         });

  //         // plus Icon
  //         plusButton.style.marginRight = "8px";
  //         buttonContainer.appendChild(plusButton);
  //         info.el.appendChild(buttonContainer);

  //         buttonContainer.appendChild(dotButton);
  //         info.el.appendChild(buttonContainer);
  //       },
  //     });

  //     calendar.render();
  //     calendarInstanceRef.current = calendar;

  //     setTimeout(() => {
  //       const todayButton = document.querySelector(".fc-today-button");
  //       if (todayButton) {
  //         todayButton.style.backgroundColor = "#2196F3";
  //         todayButton.style.color = "#fff";
  //         todayButton.style.border = "none";
  //         todayButton.style.textTransform = "capitalize";
  //       }
  //     }, 100);
  //   }
  // }, [calendardata, loading, todayBacklogCount, calenderEmpRecordID]);

  useEffect(() => {
    if (calendarInstanceRef.current) {
      calendarInstanceRef.current.removeAllEvents();
      calendarInstanceRef.current.addEventSource(calendardata);
    }
  }, [calendardata]);

  useEffect(() => {
    if (calendarRef.current && !loading) {
      if (calendarInstanceRef.current) {
        calendarInstanceRef.current.destroy();
      }

      //Dot Icon Onclick
      const handleDotClick = async (date) => {
        const istOffset = 5.5 * 60 * 60 * 1000;
        const localDate = new Date(date.getTime() + istOffset);
        const clicked = localDate.toISOString().split("T")[0];

        const now = new Date(new Date().getTime() + istOffset);
        const today = now.toISOString().split("T")[0];

        setClickedDate(clicked);
        setIsTodayDialog(clicked === today); // ✅ This sets isTodayDialog, not isToday
        setSelectedDate(date);
        setDialogOpen(true);
        setOpen(true);
        setTaskLoading(true);

        try {
          const response = await dispatch(
            CalendarpostData({
              CurDate: clicked,
              EmployeeID: calenderEmpRecordID,
            }),
          );

          if (response.payload.Status === "Y") {
            // const { CurrentdayData, ScheduledAssignedData, BackLogData, BlockedData } = response.payload.Data;
            const { Todo, BackLog, Completed, BlockedApproved, NotApproved } =
              response.payload.Data;
            setCurrentDayTasks(Todo || []);
            setYesterdayTasks(BackLog || []);
            setBacklogTasks(Completed || []);
            setBlockedTasks(BlockedApproved || []);
            setNotApprovedTasks(NotApproved || []);
            // setCurrentDayTasks(CurrentdayData || []);
            // setYesterdayTasks(ScheduledAssignedData || []);
            // setBacklogTasks(BackLogData || []);
            // setBlockedTasks(BlockedData || []);
          } else {
            toast.error(response.payload.Msg || "Something went wrong");
          }
        } catch (error) {
          toast.error("Failed to load tasks");
          console.error("Error fetching task data:", error);
        } finally {
          setTaskLoading(false);
        }
      };

      //Plus Icon Onclick

      const handlePlusClick = async (date) => {
        const istOffset = 5.5 * 60 * 60 * 1000;
        const localDate = new Date(date.getTime() + istOffset);
        const clicked = localDate.toISOString().split("T")[0];
        console.log(clicked, "--clicked");

        const now = new Date(new Date().getTime() + istOffset);
        const today = now.toISOString().split("T")[0];

        if (isManager == 0) {
          navigate("/Apps/TR132/Scrum%20Task/EditScrum%20Task/-1/A", {
            state: {
              ClickedDate: clicked,
            },
          });
        } else if (isManager == 1 && EMPID == calenderEmpRecordID) {
          // navigate("/Apps/Secondarylistview/TR263/Task%20List/132/EditTask%20List/-1/A");
          navigate("/Apps/TR132/Scrum%20Task/EditScrum%20Task/-1/A", {
            state: {
              ClickedDate: clicked,
            },
          });
        } else {
          navigate(
            "/Apps/Secondarylistview/TR263/Task%20List/132/EditTask%20List/-1/A",
          );
        }
      };
      const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
      };
      function repaintDayCells(calendar) {
        const now = new Date();
        const utc = now.getTime() + now.getTimezoneOffset() * 60000;
        const IST_OFFSET = 5.5 * 60 * 60 * 1000;
        const istNow = new Date(utc + IST_OFFSET);

        const todayDate = new Date(
          istNow.getFullYear(),
          istNow.getMonth(),
          istNow.getDate()
        );

        document.querySelectorAll(".fc-daygrid-day").forEach(cell => {
          const dateStr = cell.getAttribute("data-date");
          if (!dateStr) return;

          const cellDate = new Date(dateStr);
          cellDate.setHours(0, 0, 0, 0);

          const events = calendar
            .getEvents()
            .filter(e => e.startStr.startsWith(dateStr));

          const titles = events.map(e => (e.title || "").toLowerCase());

          let bg = "";
          let color = "#000";

          /* -------------------------------
             TODAY (TOP PRIORITY)
          --------------------------------*/
          if (cellDate.getTime() === todayDate.getTime()) {
            bg = "#81b7e4";
            color = "#fff";
          }

          /* -------------------------------
             Event-based colors
          --------------------------------*/
          else if (titles.includes("holiday")) {
            bg = "#b9ecee";
            color = "#fff";
          }
          // else if (titles.includes("weekoff")) {
          //   bg = "#f3bac296";
          //   color = "#fff";
          // }
          else if (titles.some(t => t.trim() === "week off")) {
            bg = "#f3bac296";
            color = "#fff";
          }
          else if (
            titles.some(t =>
              t.includes("casual") ||
              t.includes("sick") ||
              t.includes("medical")
            )
          ) {
            bg = "#ddcab1";
            color = "#fff";
          }

          /* -------------------------------
             Alternate box coloring
          --------------------------------*/
          else {
            if (cellDate.getDate() % 2 === 0) {
              bg = "#d0f0e0";
            } else {
              bg = "";
            }
            color = "#000";
          }

          cell.style.backgroundColor = bg;
          cell.style.color = color;
        });
      }
      const calendar = new Calendar(calendarRef.current, {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        // initialDate: currentDateString,
        events: calendardata,

        // events: eventsData,
        datesSet: function (info) {
          const visibleYear = info.view.currentStart.getFullYear().toString();

          // ✅ Only refetch if year actually changed
          if (currentYearRef.current !== visibleYear) {
            currentYearRef.current = visibleYear;

            dispatch(
              DashcalpostData({
                Year: visibleYear,
                Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                EmployeeID: EMPID,
              }),
            );
          }
        },
        eventsSet: function () {
          const calendarApi = calendarInstanceRef.current;

          if (!calendarApi) return;

          // repaint AFTER events exist in DOM
          setTimeout(() => {
            repaintDayCells(calendarApi);
          }, 0);
        },


        eventClick: function (info) {
          const clickedDate = info.event.start;
          if (!clickedDate || isNaN(new Date(clickedDate).getTime())) return;
          const ID = info.event.extendedProps.DailyID;

        },

        eventDidMount: function (info) {
          const calendar = info.view.calendar;
          const eventDate = info.event.startStr.split("T")[0];
          const status = info.event.extendedProps?.status?.trim();

          //  Hide completely if title is empty
          if (!info.event.title || info.event.title.trim() === "") {
            info.el.style.display = "none";
            return;
          }

          const titleLower = info.event.title.toLowerCase();

          //  Events where STAR should NOT appear
          const noStarTitles = [
            "holiday",
            "weekoff",
            "casual",
            "sick",
            "medical",
            "irregular",
            "absent"

          ];

          const hideStar = noStarTitles.some(t =>
            titleLower.includes(t)
          );

          // Tooltip: combine all titles for the date
          const eventsForDate = calendar
            .getEvents()
            .filter(e => e.startStr.startsWith(eventDate));

          const tooltipText = eventsForDate
            .filter(e => e.title)
            .map(e => `• ${e.title}`)
            .join("\n");

          //  Star color (only if star is shown)
          let starColor = "#000";
          if (!hideStar && status && statusColorMap[status]) {
            starColor = statusColorMap[status];
          }

          // Remove default FC styles
          const defaultTitle = info.el.querySelector(".fc-event-title");
          if (defaultTitle) defaultTitle.style.display = "none";
          info.el.innerHTML = "";

          info.el.style.background = "transparent";
          info.el.style.border = "none";
          info.el.style.padding = "0px";
          info.el.style.display = "flex";
          info.el.style.alignItems = "flex-start";
          info.el.style.fontSize = "9px";
          info.el.style.fontWeight = "bold";
          info.el.style.whiteSpace = "normal";
          info.el.style.overflow = "hidden";

          //  Star (ONLY if allowed)
          if (!hideStar) {
            const starIcon = document.createElement("span");
            starIcon.innerHTML = "★";
            starIcon.style.color = starColor;
            starIcon.style.fontSize = "12px";
            starIcon.style.marginRight = "4px";
            starIcon.style.flexShrink = "0";
            info.el.appendChild(starIcon);
          }

          // Title
          const titleElement = document.createElement("span");
          titleElement.innerText = info.event.title;
          titleElement.style.color = "#000";
          titleElement.style.wordBreak = "break-word";
          titleElement.style.flex = "1";

          info.el.appendChild(titleElement);
          info.el.setAttribute("title", tooltipText);
        },


        dayCellDidMount: function (info) {
          /* -------------------------------
              IST Today / Yesterday
          --------------------------------*/
          const now = new Date();
          const utc = now.getTime() + now.getTimezoneOffset() * 60000;
          const IST_OFFSET = 5.5 * 60 * 60 * 1000;
          const istNow = new Date(utc + IST_OFFSET);

          const todayDate = new Date(
            istNow.getFullYear(),
            istNow.getMonth(),
            istNow.getDate()
          );

          const yesterdayDate = new Date(todayDate.getTime() - 86400000);

          const cellDate = new Date(
            info.date.getFullYear(),
            info.date.getMonth(),
            info.date.getDate()
          );

          /* -------------------------------
              Events for this date
          --------------------------------*/
          const calendar = info.view.calendar;

          //  LOCAL date string (NO UTC SHIFT)
          const cellDateStr =
            info.date.getFullYear() +
            "-" +
            String(info.date.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(info.date.getDate()).padStart(2, "0");

          const eventsForDate = calendar
            .getEvents()
            .filter(e => e.startStr.startsWith(cellDateStr));

          const titles = eventsForDate.map(e =>
            (e.title || "").toLowerCase()
          );

          let bgColor = "";
          let textColor = "#000";

          if (cellDate.getTime() === todayDate.getTime()) {
            bgColor = "#81b7e4"; // Blue
            textColor = "#fff";
          }
          else if (titles.includes("holiday")) {
            bgColor = "#b9ecee"; // Green
            textColor = "#fff";
          }
          // else if (titles.includes("weekoff")) {
          //   bgColor = "#f3bac296"; // Red
          //   textColor = "#fff";
          // }
          else if (titles.some(t => t.trim() === "week off")) {
            bgColor = "#f3bac296";
            textColor = "#fff";
          }
          else if (
            titles.some(t =>
              t.includes("casual") ||
              t.includes("sick") ||
              t.includes("medical")
            )
          ) {
            bgColor = "#ddcab1"; // Orange
            textColor = "#fff";
          }
          else {
            // Checkerboard for normal days
            if (cellDate.getDate() % 2 === 0) {
              bgColor = "#d0f0e0";
            }
          }

          info.el.style.backgroundColor = bgColor;
          info.el.style.color = textColor;
          info.el.style.position = "relative";

          /* -------------------------------
              Prevent duplicate buttons
          --------------------------------*/
          if (info.el.querySelector(".dot-button")) return;

          /* -------------------------------
              Button container
          --------------------------------*/
          const buttonContainer = document.createElement("div");
          buttonContainer.style.position = "absolute";
          buttonContainer.style.bottom = "2px";
          buttonContainer.style.right = "2px";
          buttonContainer.style.zIndex = "10";

          /* -------------------------------
              Backlog count (Today only)
          --------------------------------*/
          if (
            cellDate.getTime() === todayDate.getTime() &&
            todayBacklogCount > 0
          ) {
            const backlogLabel = document.createElement("div");
            backlogLabel.innerText = `B(${todayBacklogCount})`;
            backlogLabel.style.fontSize = "11px";
            backlogLabel.style.fontWeight = "bold";
            backlogLabel.style.color = "#f44336";
            backlogLabel.style.background = "#fff";
            backlogLabel.style.borderRadius = "4px";
            backlogLabel.style.padding = "2px";
            backlogLabel.style.pointerEvents = "none";
            buttonContainer.appendChild(backlogLabel);
          }

          /* -------------------------------
              Plus button
          --------------------------------*/
          const plusButton = document.createElement("button");
          plusButton.innerHTML = "+";
          plusButton.className = "plus-button";
          plusButton.style.border = "none";
          plusButton.style.background = "transparent";
          plusButton.style.cursor = "pointer";
          plusButton.style.fontSize = "16px";
          plusButton.style.marginRight = "8px";

          plusButton.addEventListener("click", (e) => {
            e.stopPropagation();
            handlePlusClick(info.date);
          });

          /* -------------------------------
             ⋯ Dot button
          --------------------------------*/
          const dotButton = document.createElement("button");
          dotButton.innerHTML = "⋯";
          dotButton.className = "dot-button";
          dotButton.style.border = "none";
          dotButton.style.background = "transparent";
          dotButton.style.cursor = "pointer";
          dotButton.style.fontSize = "16px";

          dotButton.addEventListener("click", (e) => {
            e.stopPropagation();
            handleDotClick(info.date);
          });

          buttonContainer.appendChild(plusButton);
          buttonContainer.appendChild(dotButton);
          info.el.appendChild(buttonContainer);
        },

      });

      calendar.render();
      calendarInstanceRef.current = calendar;

      setTimeout(() => {
        const todayButton = document.querySelector(".fc-today-button");
        if (todayButton) {
          todayButton.style.backgroundColor = "#2196F3";
          todayButton.style.color = "#fff";
          todayButton.style.border = "none";
          todayButton.style.textTransform = "capitalize";
        }
      }, 100);
    }
  }, [loading, todayBacklogCount, calenderEmpRecordID]);

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      {broken && !rtl && (
        <IconButton onClick={() => toggleSidebar()}>
          <MenuOutlinedIcon />
        </IconButton>
      )}

      {loading ? (
        <p>Loading calendar data...</p>
      ) : (
        <div
          ref={calendarRef}
          style={{
            width: "100%",
            height: "350px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "10px",
          }}
        />
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={340}
        sx={{ height: "85vh" }}
      >
        <DialogTitle>
          Task Summary for {formatDate(clickedDate)}
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", right: 3, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{ height: "80vh", width: "100%", overflowX: "hidden" }}
        >
          {isManager != 0 && (
            <Box display="flex" gap={1}>
              <Button
                color="warning"
                variant="contained"
                onClick={() => setActiveTab("todo")}
              >
                To Do
              </Button>
              <Button
                color="success"
                variant="contained"
                onClick={() => setActiveTab("approved")}
              >
                To Approve
              </Button>
            </Box>
          )}
          {isTodayDialog ? (
            // --------- ✅ Design for TODAY ---------

            <Box
              display="flex"
              justifyContent="space-between"
              gap={2}
              mt={2}
              maxWidth={950}
            >
              {/* Day Task */}
              <Box flex={1}>
                <Typography variant="h6" gutterBottom>
                  {activeTab === "todo" ? "To Do" : "To Approve"}
                  {currentDayTasks.length > 0 || notApprovedTasks.length > 0
                    ? `(${activeTab === "todo" ? currentDayTasks.length : notApprovedTasks.length})`
                    : false}
                </Typography>
                {(activeTab === "todo" ? currentDayTasks : notApprovedTasks)
                  .length > 0 ? (
                  (activeTab === "todo"
                    ? currentDayTasks
                    : notApprovedTasks
                  ).map((task, index) => (
                    <Card
                      key={index}
                      sx={{
                        mb: 1,
                        backgroundColor: "#e3f2fd",
                        cursor: "pointer",
                        maxWidth: 220,
                        height: 120,
                      }}
                      onClick={() =>
                        handleCardClick(
                          task.RecordID,
                          task.TaskDate,
                          task.EmployeeAttendanceID,
                          activeTab === "todo" ? "E" : "MT",
                        )
                      }
                    >
                      <CardContent
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Tooltip title={task.Description}>
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="primary"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {task.Description}
                          </Typography>
                        </Tooltip>
                        <Tooltip title={task.Comments}>
                          <Typography
                            variant="h6"
                            color="textSecondary"
                            sx={{
                              height: 60,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {task.Comments}
                          </Typography>
                        </Tooltip>
                        <Typography variant="h6" color="textSecondary">
                          <span style={{ color: "#b71c1c" }}>
                            {task.NotApprovedDesc}
                          </span>
                        </Typography>
                        <Typography variant="h6" color="textSecondary">
                          <span style={{ color: "#b71c1c" }}>
                            {task.NotApprovedCode}
                          </span>
                        </Typography>
                        <Typography
                          variant="body2"
                          marginLeft={15}
                          sx={{
                            color:
                              task.Status === "Completed"
                                ? "green"
                                : task.Status === "Inprogress"
                                  ? "orange"
                                  : task.Status === "Transfer to"
                                    ? "blue"
                                    : task.Status === "Assigned"
                                      ? "orange"
                                      : task.Status === "Not yet started" ||
                                        task.Status === "Scheduled"
                                        ? "#CD5C5C"
                                        : "text.secondary",
                          }}
                        >
                          {task.Status}
                        </Typography>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Card
                    sx={{
                      mb: 1,
                      backgroundColor: "#e3f2fd",
                      // cursor: "pointer",
                      width: 220,
                      height: 120,
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="h6"
                        color="textSecondary"
                        sx={{
                          height: 60,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        No Tasks
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Box>

              {/* Yesterday */}
              <Box flex={1}>
                {/* <Typography variant="h6" gutterBottom>Backlog - {formattedTomorrow}</Typography> */}
                <Typography variant="h6" gutterBottom>
                  Backlog{" "}
                  {yesterdayTasks.length > 0
                    ? `(${yesterdayTasks.length})`
                    : false}
                </Typography>

                {yesterdayTasks.length > 0 ? (
                  yesterdayTasks.map((task, index) => (
                    <Card
                      key={index}
                      sx={{
                        mb: 1,
                        backgroundColor: "#fdecea",
                        cursor: "pointer",
                        width: 220,
                        height: 120,
                      }}
                      onClick={() =>
                        handleCardClick(
                          task.RecordID,
                          task.TaskDate,
                          task.EmployeeAttendanceID,
                          "P",
                        )
                      }
                    >
                      <CardContent
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Tooltip title={task.Description}>
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="primary"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {task.Description}
                          </Typography>
                        </Tooltip>
                        <Tooltip title={task.Comments}>
                          <Typography
                            variant="h6"
                            color="textSecondary"
                            sx={{
                              height: 60,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 3, // adjust for how many lines you want to show
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {task.Comments}
                          </Typography>
                        </Tooltip>
                        <Typography
                          variant="body2"
                          marginLeft={15}
                          sx={{
                            color:
                              task.Status === "Completed"
                                ? "green"
                                : task.Status === "Inprogress"
                                  ? "orange"
                                  : task.Status === "Transfer to"
                                    ? "blue"
                                    : task.Status === "Not yet started"
                                      ? "#CD5C5C"
                                      : task.Status === "Assigned" ||
                                        task.Status === "Scheduled"
                                        ? "#A865C9"
                                        : "text.secondary",
                          }}
                        >
                          {task.Status === "Assigned" ||
                            task.Status === "Scheduled"
                            ? "Pick Now"
                            : task.Status === "Dependence"
                              ? "Dependence"
                              : task.Status}
                        </Typography>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Card
                    sx={{
                      mb: 1,
                      backgroundColor: "#fdecea",
                      // cursor: "pointer",
                      width: 220,
                      height: 120,
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="h6"
                        color="textSecondary"
                        sx={{
                          height: 60,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        No Tasks
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Box>

              {/* Backlog */}
              <Box flex={1}>
                {/* <Typography variant="h6" gutterBottom>Yet To Be Approved</Typography> */}
                <Typography variant="h6" gutterBottom>
                  Completed{" "}
                  {backlogTasks.length > 0 ? `(${backlogTasks.length})` : false}
                </Typography>

                {backlogTasks.length > 0 ? (
                  backlogTasks.map((task, index) => (
                    <Card
                      key={index}
                      sx={{
                        mb: 1,
                        backgroundColor: "#e0f7e9",
                        cursor: "pointer",
                        maxWidth: 220,
                        height: 120,
                      }}
                      onClick={() =>
                        handleCardClick(
                          task.RecordID,
                          task.TaskDate,
                          task.EmployeeAttendanceID,
                          "E",
                        )
                      }
                    >
                      <CardContent
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Tooltip title={task.Description}>
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="primary"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {task.Description}
                          </Typography>
                        </Tooltip>
                        <Tooltip title={task.Comments}>
                          <Typography
                            variant="h6"
                            color="textSecondary"
                            sx={{
                              height: 60,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {task.Comments}
                          </Typography>
                        </Tooltip>
                        <Typography
                          variant="body2"
                          marginLeft={17}
                          sx={{
                            color:
                              task.Status === "Completed"
                                ? "green"
                                : task.Status === "Inprogress"
                                  ? "orange"
                                  : task.Status === "Transfer to"
                                    ? "blue"
                                    : task.Status === "Not yet started"
                                      ? "#CD5C5C"
                                      : task.Status === "Scheduled"
                                        ? "#CD5C5C"
                                        : "text.secondary",
                          }}
                        >
                          {task.Status}
                        </Typography>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Card
                    sx={{
                      mb: 1,
                      backgroundColor: "#e0f7e9",
                      // cursor: "pointer",
                      width: 220,
                      height: 120,
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="h6"
                        color="textSecondary"
                        sx={{
                          height: 60,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        No Tasks
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Box>

              {/**/}
              <Box flex={1}>
                <Typography variant="h6" gutterBottom>
                  Blocked/Approved{" "}
                  {blockedTasks.length > 0 ? `(${blockedTasks.length})` : false}
                </Typography>
                {blockedTasks.length > 0 ? (
                  blockedTasks.map((task, index) => (
                    <Card
                      key={index}
                      sx={{
                        mb: 1,
                        backgroundColor: "#FFE1F3",
                        cursor: "pointer",
                        maxWidth: 220,
                        height: 120,
                      }}
                      onClick={() =>
                        handleCardClick(
                          task.RecordID,
                          task.TaskDate,
                          task.EmployeeAttendanceID,
                          "V",
                        )
                      }
                    >
                      <CardContent
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Tooltip title={task.Description}>
                          <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            color="primary"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {task.Description}
                          </Typography>
                        </Tooltip>
                        <Tooltip title={task.Comments}>
                          <Typography
                            variant="h6"
                            color="textSecondary"
                            sx={{
                              height: 60,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {task.Comments}
                          </Typography>
                        </Tooltip>
                        <Typography
                          variant="body2"
                          marginLeft={15}
                          sx={{
                            color:
                              task.STATUS === "Completed"
                                ? "green"
                                : task.STATUS === "Inprogress"
                                  ? "orange"
                                  : task.STATUS === "Transfer to"
                                    ? "blue"
                                    : task.STATUS === "Not yet started"
                                      ? "#CD5C5C"
                                      : task.STATUS === "Blocked"
                                        ? "#CD5C5C"
                                        : task.STATUS === "Approved"
                                          ? "#00bcd4"
                                          : task.STATUS === "Scheduled"
                                            ? "#CD5C5C"
                                            : "text.secondary",
                          }}
                        >
                          {/* {task.STATUS} */}
                          {task.STATUS === "Blocked" ? "Blocked" : task.STATUS}
                        </Typography>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Card
                    sx={{
                      mb: 1,
                      backgroundColor: "#FFE1F3",
                      // cursor: "pointer",
                      width: 220,
                      height: 120,
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography
                        variant="h6"
                        color="textSecondary"
                        sx={{
                          height: 60,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        No Tasks
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Box>
            </Box>
          ) : (
            // --------- ✅ Design for OTHER DATES ---------
            <Box mt={2} maxWidth={300}>
              {currentDayTasks.length > 0 ? (
                currentDayTasks.map((task, index) => (
                  <Card
                    key={index}
                    sx={{
                      mb: 1,
                      backgroundColor: "#f1f8e9",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleCardClick(
                        task.RecordID,
                        task.TaskDate,
                        task.EmployeeAttendanceID,
                      )
                    }
                  >
                    <CardContent>
                      <Typography variant="h6" color="textSecondary">
                        {task.Comments}
                      </Typography>
                      <Typography
                        variant="body2"
                        marginLeft={26}
                        sx={{
                          color:
                            task.STATUS === "Completed"
                              ? "green"
                              : task.STATUS === "Inprogress"
                                ? "orange"
                                : task.STATUS === "Transfer to"
                                  ? "blue"
                                  : task.STATUS === "Not yet started"
                                    ? "#CD5C5C"
                                    : task.STATUS === "Scheduled"
                                      ? "#CD5C5C"
                                      : "text.secondary",
                        }}
                      >
                        {task.STATUS}
                      </Typography>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No tasks
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Datavisual1;
